<template>
  <div
    class="byg-title title-box"
    :class="border ? 'border-bottom' : ''"
  >
    <div class="title-box-left">
      <div class="title-info">
        <bgy-icon name="icon-biaotibeijing"></bgy-icon>
        {{ title }}
      </div>
      <div
        class="edit-info"
        @click="editFn"
        v-if="showEdit"
      >
        <el-tooltip content="编辑">
          <bgy-icon name="icon-bianji"></bgy-icon>
        </el-tooltip>
        <!-- 编辑 -->
      </div>
      <slot name="title"></slot>
    </div>

    <div
      class="title-box-right"
      v-if="showRight"
    >
      <slot name="right">
        <bgy-icon
          :name="toggleState === 1 ? 'icon-xian-shouqi' : 'icon-xian-zhankai'"
          @click.native="toggleFn"
          :style="{color: themeColors[6]}"
        ></bgy-icon>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BgyTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    showRight: {
      type: Boolean,
      default: false
    },
    toggleState: {
      type: Number
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    themeColors() {
      return this.$store.getters.themeColors;
    }
  },
  methods: {
    editFn() {
      this.$emit('edit');
    },
    toggleFn() {
      this.$emit('toggle');
    }
  }
};
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 10px;
  line-height: normal;

  &.border-bottom {
    border-bottom: 1px solid #ebeef5;
  }

  .title-box-left {
    display: flex;
    align-items: center;
  }

  .title-box-right {
    .bgy-icon {
      font-size: 18px;
    }
  }

  .title-info {
    margin-right: 20px;
  }

  .bgy-icon {
    position: relative;
    top: 3px;
    color: var(--color-primary);
    font-size: 16px;
    outline: none;
  }

  .edit-info {
    color: var(--color-primary);

    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }
}
</style>
